import { render } from "./CertMedicalPending.vue?vue&type=template&id=5f6187c8"
import script from "./CertMedicalPending.vue?vue&type=script&lang=js"
export * from "./CertMedicalPending.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__